import moment from "moment";

export default {
    mixins: [],
    data: () => ({}),
    computed: {},
    methods: {
        getIdxCurrentAlbum() {
            const uuid = this.$route.query.uuid;
            return Object.values(this.$store.state.albumes).findIndex(
                (item) => item.uuid == uuid
            );
        },
        /**
         * It takes a date and a number of days and returns the number of days between the date and the
         * number of days
         * @param date - The date to be compared.
         * @param [dateExpiry=30] - The number of days after which the cookie will expire.
         * @returns The number of days between the date and the dateExpiry.
         */
        diffDays(date, dateExpiry = 30) {
            /* Converting the date to a moment object. */
            let visitDate = moment(date, "YYYY-MM-DD");
            /* Converting the current date to a moment object. */
            let dateNow = moment(moment(), "YYYY-MM-DD");
            /* Subtracting the number of days between the date and the dateExpiry. */
            let diffDay = dateExpiry - dateNow.diff(visitDate, "days");

            /* Checking if the number of days between the date and the dateExpiry is greater than 0. If
            it is, it returns the number of days between the date and the dateExpiry. */
            if (diffDay > 0) {
                return diffDay;
            }

            /* Returning 0. */
            return 0;
        },
        chunk(items, size) {
            const chunks = [];
            items = [].concat(...items);

            while (items.length) {
                chunks.push(items.splice(0, size));
            }

            return chunks;
        },
        /**
         * The function organizes an array of countries by moving Mexico and USA to the beginning.
         * @param countries - an array of objects representing countries.
         * @returns an array of countries with Mexico and USA as the first two elements
         */
        topCountries(countries) {
            /* This code block is checking if the `countries` array is empty or not. If the array is
            empty, it immediately returns the same empty array */
            if (!countries.length) {
                return countries;
            }

            // If the array contains value, we carry out the operation to organize MEX and USA as first
            countries.map((item, idx) => {
                if (item.iSO === 'MEX' || item.iSO === 'USA') {
                    countries.splice(idx, 1);countries.splice(0, 0, item);
                }
            });

            return countries;
        }
    }
};
